import { DISH_CO2_IMPACT_DEFAULT } from "../constants/constants";
import { ISeatingContent, IDefaultSeatingContent, IDefaultDishContent, IPriceModelContent, IOfficeContent, IDishContent, IBookingContent, IEaterGroupContent } from "../planEatApi/PlanEatFacade";

export function resetSeating(): ISeatingContent {
   return {
        id: '',
        name:"",
        description:"",
        officeId: "",
        seatingName: "",
        seatingStart: "",
        seatingEnd: "",
        seatingCapacity: 0,
        seatingDishes: [],
        priceModelId: "",
        priceModelVersion: ""
    }
}

export function resetDefaultSeating (): IDefaultSeatingContent {
    return {
        defaultSeatingId: '',
        defaultSeatingName : '',
        defaultSeatingStartTime: '',
        defaultSeatingEndTime: '',
        defaultSeatingCapacity: 0,
        defaultSeatingDishes:[],
        defaultSeatingPriceModelId: '',
    }
}

export function resetDefaultMenuItem (): IDefaultDishContent {
    return {
        defaultDishId: "",
        defaultDishName: "",
        defaultDishDescription: "",
        defaultDishFoodCategories: [],
        defaultDishAllergens: []
    }
}

export function resetPriceModel(): IPriceModelContent {
    return {
        id: "",
        description: "",
        name: "",
        officeId: "",
        priceModelParameters: "",
        priceModelType: ""
    }
}

export const resetOffice: IOfficeContent = {
    id: "",
    name: "",
    description: "",
    companyId: "",
    officeName: "",
    officeAddress: "",
    officeAdminIds: [],
    defaultSeatings: [],
    defaultAvailability: [],
    defaultDishesContent: [],
    officeSettings: {canCommentOnBookings: false} // TODO
}

export const resetDish: IDishContent = {
    id: "",
    name: "name",
    description: "description",
    officeId: "",
    dishTitle: "",
    dishDescription: "",
    foodCategories: [],
    allergens: [],
    co2Impact: DISH_CO2_IMPACT_DEFAULT
}


export const resetEaterGroup: IEaterGroupContent = {
    id: "",
    name: "",
    description: "",
    officeId: "",
    eaterGroupName: "",
    eaterGroupCVR: "",
    eaterGroupAddress: "",
    eaterGroupPhoneNumber: "",
    eaterGroupAdminIds: [],
}